import { Input, InputGroup, InputGroupIcon, ShellIconSearch } from '@zrsystem/ui';
import type { ReactElement } from 'react';

import './chat-list-search.css';

export interface ChatListSearchProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
}

export function ChatListSearch({ value, onChange }: ChatListSearchProps): ReactElement {
  return (
    <div className="chat-list-search">
      <InputGroup hasIcon>
        <InputGroupIcon>
          <ShellIconSearch size={14} />
        </InputGroupIcon>
        <Input
          value={value}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          placeholder="Buscar conversa ou nome"
          aria-label="Buscar conversa ou nome"
        />
      </InputGroup>
    </div>
  );
}
